import axiosInstance from "../axiosClient";




export const getOperations = async (token, page, pageSize, filters = {}, sortOrder, statusFilter, organizationId = null, includeNoAuths = true) => {
  try {
      const response = await axiosInstance.get(
          `/missionLog/user?page=${page}&pageSize=${pageSize}`,
          {
              headers: {
                  Authorization: `Bearer ${token}`,
              },
              params: {
                  ...filters,
                  sortOrder: sortOrder,
                  statusFilter: statusFilter?.join(','),
                  organizationId: organizationId || 'individual', // Pass organization context
                  includeNoAuths: includeNoAuths, // Pass flag to include operations without authorizations
              },
          }
      );
      return response.data.operations;
  } catch (error) {
      throw error;
  }
};


// export const cancelOperation = async (operationId) => {
//     const token = getToken();
//
//   try {
//     const response = await axiosInstance.patch(
//       `/missionLog/cancel_operation/${operationId}`,
//       {},
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Error cancelling operation:", error);
//     throw error;
//   }
// };


export const cancelAuthorization = async (token,userId, operationId, authorizationId) => {

  try {
    const response = await axiosInstance.post(
        `/missionLog/cancel_authorization/${userId}/${operationId}/${authorizationId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const deleteAuthorization = async (token,userId, operationId, authorizationId) => {

  try {
    const response = await axiosInstance.post(
        `/missionLog/delete_authorization/${userId}/${operationId}/${authorizationId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const ackRescindAuthorization = async (token,userId, operationId, authorizationId) => {

    try {
        const response = await axiosInstance.post(
            `/missionLog/rescind_authorization/${userId}/${operationId}/${authorizationId}`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const ackInvalidCancelAuthorization = async (token,userId, operationId, authorizationId) => {

    try {
        const response = await axiosInstance.post(
            `/missionLog/invalid_authorization/${userId}/${operationId}/${authorizationId}`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * Get operation and authorization geometries for map display
 * @param {string} token - Auth token
 * @param {number} operationId - Operation ID
 * @returns {Promise<Object>} Operation and authorization geometries
 */
export const getOperationGeometries = async (token, operationId) => {
    try {
        const response = await axiosInstance.get(
            `/missionLog/geometries/${operationId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};